var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d0d0d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8283f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc162c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd84e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcd036"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v11.428571h-16z",
    fill: "url(#c)",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v11.4285714z",
    fill: "url(#d)",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.80952381 9.52380952-.53874802.15779566.15779564-.53874804-.15779564-.53874804.53874802.15779566.53874802-.15779566-.15779564.53874804.15779564.53874804z",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.80952381 4.95238095-.53874802.15779564.15779564-.53874802-.15779564-.53874802.53874802.15779564.53874802-.15779564-.15779564.53874802.15779564.53874802z",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.9047619 6.85714286-.53874802.15779564.15779564-.53874802-.15779564-.53874803.53874802.15779565.53874803-.15779565-.15779564.53874803.15779564.53874802z",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.33333333 6.47619048-.53874802.15779564.15779564-.53874802-.15779564-.53874803.53874802.15779564.53874803-.15779564-.15779565.53874803.15779565.53874802z",
    mask: "url(#f)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m10.777853 5.29461139c-.0912114-.0547268-.1651528-.18364094-.1651527-.28677712v-.70212504c0-.10365583-.0745777-.16282626-.1874307-.1252086l-.43326069.14442025c-.10351512.03450503-.26200838.03761766-.37486133 0l-.43326072-.14442025c-.10351513-.03450503-.11501707-.10592503-.02227795-.1615685l1.01656469-.60993879c.0912112-.0547268.1402934-.17366929.1026758-.28652227l-.1444203-.43326074c-.034505-.10351509.0121008-.16257143.1249538-.12495377l.4332608.14442025c.103515.03450503.2308787-.0099367.2865222-.10267583l.6099388-1.01656464c.0547268-.09121132.1239508-.09057504.1615685.02227794l.1444203.43326074c.034505.10351509.0376176.26200832 0 .37486129l-.1444203.43326075c-.034505.10351508.0220724.18743064.1252086.18743064l.7021251-.00000004c.1036557 0 .2311336.07241358.286777.16515271l.6099388 1.01656468c.0547269.09121132.0107198.18282709-.0881848.20260802l-.972317.1944634c-.10343.020686-.204951.12582722-.2247318.22473183l-.1944634.97231709c-.020686.10342997-.1098689.14382836-.202608.08818488z",
    fill: "url(#e)",
    mask: "url(#f)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPg);
export default __webpack_public_path__ + "static/media/PG.83829f01614613969e4b63ba12cac65e.svg";
export { ForwardRef as ReactComponent };